import BeeIcon from './icon.vue'

BeeIcon.install = (Vue) => {
  Vue.component(BeeIcon.name, BeeIcon)
}

export default BeeIcon



// WEBPACK FOOTER //
// ./src/components/icon/index.js